<template>
  <a
    href="#"
    @click.prevent="clickStr"
    class="ut-mt-4 md:ut-mt-0 md:ut-mr-8 ut-text-sm"
    :class="{ 'email': email, 'phone' : !email }"
  >{{ strValue }}</a>
</template>

<script>
export default {
  name: 'ProspectingClickToShow',
  props: {
    str: {
      default: '',
      required: true,
    },
    email: {
      default: false,
      required: false,
    },
    formate: {
      default: false,
      required: true,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    formatString() {
      if (this.email) {
        return `${this.str.substr(0, 1)}..@...`;
      }
      return `${this.str.substr(0, 4)} ... ...`;
    },
    clickStr() {
      if (this.email) {
        this.clickEmail();
      } else {
        this.clickPhone();
      }
      if (!this.formate) {
        this.$emit('clicked-show');
      }
    },
    clickPhone() {
      if (this.formate) {
        window.location = `tel: ${this.str}`;
      }
    },
    clickEmail() {
      if (this.formate) {
        window.location = `mailto: ${this.str}`;
      }
    },
  },
  computed: {
    strValue() {
      if (!this.formate) {
        return this.formatString();
      }
      return this.str;
    },
  },
};
</script>

<style scoped lang="scss">
  a {
    @apply ut-inline-block ut-tracking-wide;
  }
</style>
